import axiosInstance from '@/shared/api/axios-instance';

import type { IncomingInvoice, IncomingInvoiceListItem } from '../model/types';

import { IncomingInvoiceFilterResponse, IncomingInvoiceListResponse } from './types';

export type FetchIncomingInvoicesListParams = Record<string, unknown>;
export async function fetchIncomingInvoicesList(params: FetchIncomingInvoicesListParams): Promise<{
  list: IncomingInvoiceListItem[];
  count: number;
  moreRecords: boolean;
  totalRecordCountLimitExceeded: boolean;
}> {
  const response = await axiosInstance.post<IncomingInvoiceListResponse>('/eingangsrechnung/List', params);

  if (!response.data.isSuccess) {
    throw new Error('Failed to fetch incoming invoices list');
  }

  const data = response.data.data;

  return {
    count: data.count,
    list: data.items.map(item => item.attributes),
    moreRecords: data.morerecords,
    totalRecordCountLimitExceeded: data.totalRecordCountLimitExceeded
  };
}

export type FetchIncomingInvociesFiltersParams = {
  columnName: string | null;
  searchValue: string | null;
};
export async function fetchIncomingInvoicesFilters(params: FetchIncomingInvociesFiltersParams): Promise<any[]> {
  const response = await axiosInstance.post<IncomingInvoiceFilterResponse>(
    '/eingangsrechnung/GetEingangsrechnungFilterData',
    params
  );

  if (!response.data.isSuccess) {
    throw new Error('Failed to fetch incoming invoices filters list');
  }

  return response.data.data;
}

export async function fetchIncomingInvoice(id: string): Promise<IncomingInvoice> {
  const response = await axiosInstance.post('/eingangsrechnung/getEingangsrechnungById', { eingangsrechnungId: id });

  if (!response.data.isSuccess) {
    throw new Error('Failed to fetch incoming invoice');
  }

  return response.data.data;
}
